module.exports = __webpack_public_path__ + "LG_G6.svg?8018728b9bb98347f93c6b6a7d198949";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/LG_G6.svg
// module id = 197
// module chunks = 0